import React, { useState } from 'react';
import useAuth from '../hooks/AuthHook.jsx';
import { CREDENTIAL_SOURCES, LOCUM_CREDENTIALS, PII_STATUSES, USER_ROLES } from '../Constants';
import { dismissPiiReminderForSession, getMissingCredentials, wasPiiReminderDismissed } from '../../helpers/CredentialUtils.js';
import CredentialsPromptModal from './CredentialsPromptModal.jsx';

/**
 * Dismissible reminder shown once per browser session to an onboarded locum who hasn't answered the PII
 * question. It also asks for ABN or AHPRA if those are empty. It doesn't block anything and has no
 * follow-up note on dismiss; the hard block happens when they try to request a shift.
 * A locum who answered "No" is not reminded again (the modal also closes on a saved "No"), since they have
 * made their choice and are only prompted when they try to request a shift.
 */
const PiiReminderPrompt = () => {
  const { authed, profile } = useAuth();
  const [dismissed, setDismissed] = useState(wasPiiReminderDismissed);
  const isOnboardedLocum = authed && profile && profile.role === USER_ROLES.LOCUM && profile.completedOnboarding;
  // A locum who answered "No" has made their choice; they're only blocked when they try to request a shift.
  const hasDeclaredNone = profile && profile.piiStatus === PII_STATUSES.DECLARED_NONE.key;
  if (dismissed || !isOnboardedLocum || hasDeclaredNone || !getMissingCredentials(profile).includes(LOCUM_CREDENTIALS.PII)) {
    return null;
  }
  const close = () => {
    dismissPiiReminderForSession();
    setDismissed(true);
  };
  return (
    <CredentialsPromptModal close={close} source={CREDENTIAL_SOURCES.LOGIN_PROMPT} />
  );
};

export default PiiReminderPrompt;
